module.exports = __webpack_public_path__ + "static/media/车身.5d5423c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/project/dongfeng/faultDiagnosis/demo/image/车身.png
// module id = 1716
// module chunks = 174